import { render, staticRenderFns } from "./AdminSurfController.vue?vue&type=template&id=56b7354d&scoped=true"
import script from "./AdminSurfController.vue?vue&type=script&lang=js"
export * from "./AdminSurfController.vue?vue&type=script&lang=js"
import style0 from "./AdminSurfController.vue?vue&type=style&index=0&id=56b7354d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7354d",
  null
  
)

export default component.exports